import { collectAllPages } from "@examspark/common";
import {
  QuerySearchArgs,
  SearchableResourceConnectionNew,
} from "@examspark/types";

import { GraphQLAPI } from "../../client";
import { search as searchQueries } from "../../queries";

export * from "./item";

export const searchPassages = async (variables?: QuerySearchArgs) => {
  const result = await GraphQLAPI.client.query<{
    search: SearchableResourceConnectionNew;
  }>({
    query: searchQueries.search(),
    variables: {
      ...variables,
      limit: 0,
      aggsNew: [
        {
          name: "contextIds",
          type: "terms",
          field: "contextIds",
          size: 50,
        },
      ],
    },
  });

  return result.data?.search;
};

export const search = async (
  variables?: QuerySearchArgs,
  options?: { allPages?: boolean },
) => {
  const { authorizationContext, ...otherVariables } = variables ?? {};

  const pages = await collectAllPages(async (nextToken) => {
    const result = await GraphQLAPI.client.query<{
      search: SearchableResourceConnectionNew;
    }>({
      query: searchQueries.search({
        fields: `
            id
            sk
            grade
            idInc
            name
            subject
            wordCount
            lexile
            lexileMin
            lexileMax
            referencesIds
            tags {
              key
              type
              value
            }
          `,
      }),
      variables: {
        ...otherVariables,
        nextToken: nextToken ?? variables?.nextToken,
      },
      overrideIdentityContext: authorizationContext ?? undefined,
    });

    if (result.data?.search == null) return undefined;

    return {
      ...result.data?.search,
      nextToken: options?.allPages ? result.data?.search.nextToken : undefined,
    };
  });

  if (pages.length === 0) return undefined;

  return {
    ...pages[0],
    items: pages.flatMap((page) => page.items ?? []),
  };
};
